import React from "react";

const SvgAutoContent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g>
      <path
        d="M8.00008 15.3333C6.80008 15.3333 5.67508 15.0583 4.62508 14.5083C3.57508 13.9583 2.70008 13.1889 2.00008 12.2V14H0.666748V10H4.66675V11.3333H3.03341C3.60008 12.1667 4.31953 12.8195 5.19175 13.2917C6.06397 13.7639 7.00008 14 8.00008 14C9.27786 14 10.4362 13.6333 11.4751 12.9C12.514 12.1667 13.2445 11.1945 13.6667 9.98335L14.9667 10.2833C14.4667 11.7945 13.5779 13.0139 12.3001 13.9417C11.0223 14.8695 9.58897 15.3333 8.00008 15.3333ZM0.700081 7.33335C0.777859 6.5889 0.955637 5.87501 1.23341 5.19168C1.51119 4.50835 1.89453 3.87779 2.38341 3.30001L3.33341 4.25001C2.97786 4.70557 2.68897 5.19168 2.46675 5.70835C2.24453 6.22501 2.10564 6.76668 2.05008 7.33335H0.700081ZM4.26675 3.31668L3.31675 2.36668C3.90564 1.87779 4.53897 1.49168 5.21675 1.20835C5.89453 0.925012 6.60008 0.755568 7.33341 0.700012V2.03335C6.76675 2.0889 6.22786 2.22779 5.71675 2.45001C5.20564 2.67223 4.7223 2.96112 4.26675 3.31668ZM11.7501 3.31668C11.2945 2.96112 10.8084 2.67223 10.2917 2.45001C9.77508 2.22779 9.23341 2.0889 8.66675 2.03335V0.700012C9.41119 0.766679 10.1251 0.938901 10.8084 1.21668C11.4917 1.49446 12.1223 1.87779 12.7001 2.36668L11.7501 3.31668ZM13.9667 7.33335C13.9112 6.76668 13.7723 6.22501 13.5501 5.70835C13.3279 5.19168 13.039 4.70557 12.6834 4.25001L13.6334 3.30001C14.1223 3.87779 14.5056 4.50835 14.7834 5.19168C15.0612 5.87501 15.2334 6.5889 15.3001 7.33335H13.9667Z"
        fill="currentColor"
      />
      <path
        d="M5.33325 10.6667H6.34913L6.85706 9.13332H9.17452L9.68246 10.6667H10.6666L8.50786 4.66666H7.49198L5.33325 10.6667ZM7.14278 8.26666L7.96817 5.76666H8.03166L8.85706 8.26666H7.14278Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default SvgAutoContent;
